'use client';
import React from 'react';
import type {
  RestaurantFaq,
  Store,
} from '@/lib/types/customer/restaurant/StoreProfile';
import FAQList from '@/components/shared/FAQList';
import { ActiveSubscription } from '@/lib/types/customer/restaurant/ActiveSubscription';
import { isPaidSubscriber } from '@/lib/helpers/functions';
import If from '@ui/If';
import { useTranslations } from 'next-intl';
import NotAvailableCard from '@/shared/NotAvailableCard';

type Props = {
  store: Store;
  faqs: RestaurantFaq[];
  activeSubscription: ActiveSubscription;
};

export default function RestaurantFAQ({
  faqs,
  activeSubscription,
  store,
}: Props) {
  const t = useTranslations('');

  if (!store.features.crud_on_faq) {
    return <></>;
  }
  if (!faqs || faqs.length <= 0) {
    return <></>;
  }

  return (
    <section className="">
      <div className="py-10">
        <div className="mb-6">
          <h3 className="text-h3 font-[900] leading-[140%] text-title">FAQ</h3>
        </div>
        <If condition={faqs && faqs.length > 0} fallback={<NotAvailableCard />}>
          <FAQList faqs={faqs} />
        </If>
      </div>
    </section>
  );
}
